const TYPE = "ADMIN";
export default {
  path: "tenant",
  meta: { label: "Tenant" },
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      meta: {
        requiresAuth: true,
        type: TYPE,
      },
      component: () => import("@/views/tenant/Tenant.vue"),
    },
    {
      path: "create",
      name: "CreateTenant",
      meta: {
        label: "Onboard Tenant",
        requiresAuth: true,
        type: TYPE,
      },
      component: () => import("@/views/tenant/CreateTenant.vue"),
    },
    {
      path: "view/:id",
      name: "viewTenant",
      meta: {
        label: "View Tenant",
        requiresAuth: true,
        type: TYPE,
      },
      component: () => import("@/views/tenant/viewTenant.vue"),
    },
    {
      path: "edit/:id",
      name: "editTenant",
      meta: {
        label: "Edit Tenant",
        requiresAuth: true,
        type: TYPE,
      },
      component: () => import("@/views/tenant/editTenant.vue"),
    },
  ],
};
